// @flow
const displayPrice = (price: number) => {
  const integer = Math.floor(price / 100);
  const cents = (price % 100 + "").padStart(2, "0");

  return `${integer},${cents}\xA0€`;
};

export default displayPrice;



// WEBPACK FOOTER //
// ./src/commons/displayPrice.js